import i18n from "i18next";
export default function ConvertToString(inputVal, digits = -1, defaultstring = "---") {
  if (inputVal === "") return defaultstring;
  if (inputVal === null) return defaultstring;
  if (inputVal === "INF") return inputVal;

  if (isNaN(inputVal)) return defaultstring;

  if (typeof inputVal === "number") {
    if (!Number.isFinite(inputVal)) return defaultstring;
  }
  var rs = digits == -1 ? Number(inputVal).toString() : Number(inputVal).toFixed(digits);
  if (i18n.resolvedLanguage === "en" || i18n.resolvedLanguage === "es-ES") {
    return rs;
  }
  return String(rs).replace(".", ",");
}

function EnToNumber(inputVal) {
  var t = String(inputVal).replace(".", ".");
  return Number(t);
}
function DeToNumber(inputVal) {
  var t = String(inputVal);

  return t;
}

export function ConvertToValidNumber(inputVal) {
  return i18n.resolvedLanguage === "de-DE" ? DeToNumber(inputVal) : EnToNumber(inputVal);
}

export function getValue(inputValue) {
  if (
    String(inputValue) === "NaN" ||
    String(inputValue) === Number.NaN.toString() ||
    inputValue === null
  )
    return "";
  if (isNaN(inputValue)) return inputValue;

  return inputValue;
}

export function isValidNumber(inputVal) {
  if (String(inputVal).trim() === "") return false;
  return typeof inputVal === "number" && !isNaN(inputVal) ? true : false;
}

export function getClassName(
  inputVal,
  truevalue = "change-input",
  falsevalue = "change-input-invalid"
) {
  if (inputVal === 0) return truevalue;
  if (inputVal === true) return truevalue;
  if (inputVal === false) return falsevalue;
  let test = isValidNumber(getValue(inputVal)) ? truevalue : falsevalue;
  return test;
}
